import { setLocalStorageMultipleItems, STORAGE_KEY } from "./storage";
export const resetLoginInfo = () => {
  setLocalStorageMultipleItems({
    [STORAGE_KEY.token]: "",
    [STORAGE_KEY.permissionList]: [],
  });
};
